import {Injectable, Injector} from "@angular/core";

import {ReportError} from "app/app.service";
import {BaseListService, BatchRequest, ListRequest} from "app/services/domain/base.service";
import * as Models from "app/services/proxy/model/models";

@Injectable()
export class TagPostureCloudAccountSummaryService extends BaseListService<CloudAccountSummaryListRequest, CloudAccountSummaryBatchRequest, Models.TagPostureCloudAccountSummary>
{
    constructor(inj: Injector)
    {
        super(inj, Models.TagPostureCloudAccountSummary);
    }

    @ReportError
    public list(request: CloudAccountSummaryListRequest): Promise<Models.ListResponse>
    {
        const innerReq = Models.TagPostureSummaryListRequest.newInstance({
                                                                             ...request.request,
                                                                             list_context: request.list_context
                                                                         });
        return this.domain.apis.tagPosturesApi.cloudAccountSummaryList(request.snapshotId, innerReq);
    }

    @ReportError
    protected getBatchResponseImpl(request: CloudAccountSummaryBatchRequest): Promise<Models.TagPostureCloudAccountSummaryBatchResponse>
    {
        return this.domain.apis.tagPosturesApi.cloudAccountSummaryBatch(request.snapshotId, request.request);
    }

    protected createBatchRequest(listReq: CloudAccountSummaryListRequest,
                                 ids: string[]): CloudAccountSummaryBatchRequest
    {
        return new CloudAccountSummaryBatchRequest(listReq.snapshotId, ids);
    }
}

export class CloudAccountSummaryListRequest implements ListRequest
{
    public list_context: Models.ListContext;

    constructor(public readonly snapshotId: string,
                public readonly request: Models.TagPostureSummaryListRequest)
    {
        this.list_context = request.list_context;
    }
}

export class CloudAccountSummaryBatchRequest implements BatchRequest
{
    public readonly request: Models.BatchRequest;

    get ids(): string[]
    {
        return this.request.ids;
    }

    constructor(public readonly snapshotId: string,
                ids: string[])
    {
        this.request = Models.BatchRequest.newInstance({ids: ids});
    }
}
